import React, { useEffect } from "react";
import { AnnouncementBar } from "./AnnouncementBar";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

const META_DESC =
  "The most knowledgeable people are often the least visible. The Authority Gap helps experts build authority ecosystems that make their expertise discoverable, trusted, and monetizable.";

export const Layout = ({ title, path = "/", children }) => {
  useEffect(() => {
    if (title) document.title = title;
    // Meta description
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", META_DESC);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://theauthoritygap.co${path === "/" ? "" : path}`);

    // OG tags
    const setOg = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setOg("og:site_name", "The Authority Gap");
    setOg("og:type", "website");
    setOg("og:title", title || "The Authority Gap");
    setOg("og:description", META_DESC);
    setOg("og:url", `https://theauthoritygap.co${path === "/" ? "" : path}`);
  }, [title, path]);

  return (
    <div className="App" data-testid="page-root">
      <AnnouncementBar />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
